import {
  INITIALIZE,
  CHANGE_ROUTE,
  SETUP_FEATURE_GATES,
  SETUP_VWO,
  ADD_VWO_DECISION,
  ERROR,
  PAY_FREQUENCY_LOOKUP,
  SETUP_TOKEN,
  SETUP_SYNCHRONY_FLOW,
  ADD_SYNCHRONY_PHONE_CHANGED,
  SETUP_SHOPIFY_FLOW,
  SET_DEDGE_TOKEN,
  SET_NEW_USER_FLOW,
  SET_RETURN_USER_FLOW,
  SET_SHOPIFY_SESSION_ID,
  SET_SHOPIFY_ORG_ID,
  SET_OFFER_PAGE_FLOW,
  SET_INSTORE_VCC_FLOW,
  ADD_CHECKOUT_ALL,
} from '../actionTypes';

const initialState = {
  initialize: {
    token: '3c007be61d17302fd4e49ff26e2ed471f844dab4',
  },
  error: null,
  vwo: {
    decisions: [],
    client: null,
  },
};

export default function technical(state = initialState, action) {
  switch (action.type) {
    case INITIALIZE: {
      return {
        ...state,
        initialize: {
          ...state.initialize,
          ...action.payload,
        },
      };
    }
    case SETUP_TOKEN: {
      return {
        ...state,
        initialize: {
          ...state.initialize,
          token: action.payload || '3c007be61d17302fd4e49ff26e2ed471f844dab4',
        },
      };
    }
    case PAY_FREQUENCY_LOOKUP: {
      return {
        ...state,
        segmentSessionId: action.payload?.session_id || null,
        retailerName: action.payload?.retailer_name || null,
        retailerId: action.payload?.retailer_id || null,
        retailerWebsite: action.payload?.retailer_website || null,
        availableLimit: action.payload?.available_limit || null,
      };
    }
    // The checkout response also carries retailer_id/retailer_name (confirmed against the real
    // API) - the offerpage/Shopify flow never dispatches PAY_FREQUENCY_LOOKUP with a real
    // payload (Katapult.js only sends { payfrequency_exists: true } there), so retailerId/
    // retailerName above stay null for that flow otherwise. Only overwrite when the checkout
    // payload actually has a value, so a flow that already set these correctly isn't clobbered.
    case ADD_CHECKOUT_ALL: {
      return {
        ...state,
        retailerName: action.payload?.retailer_name ?? state.retailerName,
        retailerId: action.payload?.retailer_id ?? state.retailerId,
      };
    }
    case SETUP_FEATURE_GATES: {
      const featureGatesNormalized = {};
      if (action.payload) {
        // eslint-disable-next-line no-restricted-syntax
        for (const [key, value] of Object.entries(action.payload)) {
          featureGatesNormalized[key] = value.active;
        }
      }
      return {
        ...state,
        featureGates: featureGatesNormalized,
      };
    }
    case ERROR: {
      return {
        ...state,
        error: action.payload,
      };
    }
    case CHANGE_ROUTE: {
      return {
        ...state,
        route: action.payload,
      };
    }
    case SETUP_VWO: {
      return {
        ...state,
        vwo: {
          ...state.vwo,
          client: action.payload,
        },
      };
    }
    case ADD_VWO_DECISION: {
      if (!action.payload) {
        return state;
      }
      return {
        ...state,
        vwo: {
          ...state.vwo,
          decisions: [...state.vwo.decisions, action.payload],
        },
      };
    }
    case SETUP_SYNCHRONY_FLOW: {
      return {
        ...state,
        synchrony: action.payload,
      };
    }
    case ADD_SYNCHRONY_PHONE_CHANGED: {
      return {
        ...state,
        synchronyPhoneChanged: action.payload,
      };
    }
    case SETUP_SHOPIFY_FLOW: {
      return {
        ...state,
        shopify: action.payload,
      };
    }
    case SET_DEDGE_TOKEN: {
      return {
        ...state,
        DEdgeToken: action.payload,
      };
    }
    case SET_NEW_USER_FLOW: {
      return {
        ...state,
        shopify: {
          ...state.shopify,
          isNewUserFlow: action.payload,
        },
      };
    }
    case SET_RETURN_USER_FLOW: {
      return {
        ...state,
        shopify: {
          ...state.shopify,
          isReturnUserFlow: action.payload,
        },
      };
    }
    case SET_SHOPIFY_SESSION_ID: {
      return {
        ...state,
        shopifySessionId: action.payload,
      };
    }
    case SET_SHOPIFY_ORG_ID: {
      return {
        ...state,
        shopifyOrgId: action.payload,
      };
    }
    case SET_OFFER_PAGE_FLOW: {
      return {
        ...state,
        offerPageFlow: action.payload,
      };
    }
    case SET_INSTORE_VCC_FLOW: {
      return {
        ...state,
        instoreVccFlow: {
          ...state.instoreVccFlow,
          ...action.payload,
        },
      };
    }
    default:
      return state;
  }
}
